import React from 'react';
import { Input, InputProps } from '../index';

export interface NumberInputProps extends Omit<InputProps, 'onChange' | 'value'> {
  value?: string | number;
  onChange?: (value: string) => void;
}

export const NumberInput = React.forwardRef<any, NumberInputProps>(({
  value,
  onChange,
  ...props
}, ref) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value: inputValue } = e.target;

    const reg = /^-?\d*(\.\d*)?$/;

    // Allow empty string, '-', or valid number pattern
    if (reg.test(inputValue) || inputValue === '' || inputValue === '-') {
      onChange?.(inputValue);
    }
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (!onChange || !value) return;

    let valueStr = String(value);

    // Remove trailing '.' or standalone '-'
    if (valueStr.charAt(valueStr.length - 1) === '.' || valueStr === '-') {
      valueStr = valueStr.slice(0, -1);
    }

    // Remove leading zeros (except for "0" or "0.x")
    if (valueStr && valueStr !== '0') {
      valueStr = valueStr.replace(/^(-?)0+(\d)/, '$1$2');
    }

    onChange(valueStr);

    // Call original onBlur if provided
    props.onBlur?.(e);
  };

  return (
    <Input
      {...props}
      ref={ref}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
});

NumberInput.displayName = 'NumberInput';